import React, { useState } from 'react';
import styled from 'styled-components';
import images from 'rc-images';
import { withRouter } from 'react-router-dom';
import {
  MiloHand,
  SearchIcon,
  CloseIcon,
  MiloInput
} from './components';


const Container = styled.div`
  position: relative;
  height: 145px;
  background-image: url(${images.searchBoxMilo});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
`;


const ElContainer = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
`;


const Searchbox = ({
  onSearch,
  term,
  history,
  cancelSearch
}) => {
  const [val, setVal] = useState('');


  return (
    <Container>
      <MiloHand />
      <ElContainer>
        <SearchIcon />
        <MiloInput
          value={term}
          setVal={setVal}
          onSearch={onSearch}
          cancelSearch={cancelSearch}
        />
        {
          history.location.pathname !== '/wgw'
          || val.length !== 0 ? (
            <CloseIcon
              history={history}
              onSearch={onSearch}
              setVal={setVal}
              val={val}
            />
            ) : (
              null
            )
        }
      </ElContainer>
    </Container>
  );
};

export default withRouter(Searchbox);
